import { useQuery } from "@tanstack/react-query";
import { getChallenge } from "@/sales-tools/challenges/api/getChallenge";
import { usePartner } from "@/sdk";

export const useChallenges = () => {
    const partner = usePartner();
    const { data, isLoading, isError, isFetching } = useQuery({
        queryKey: [`get-challenge`, partner],
        queryFn: async () => getChallenge(partner),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: 1,
        refetchInterval: 15000,
    });
    return { data, isLoading, isError, isFetching };
};
